<template>
    <div class="w-full py-4">
        <RadioGroup v-model="selected">
            <RadioGroupLabel class="sr-only">Aantal</RadioGroupLabel>
            <div class="flex flex-wrap rounded-md" :class="{ pulse: !qty }">
                <RadioGroupOption
                    as="template"
                    v-for="number in max"
                    :key="number"
                    :value="number"
                    v-slot="{ active, checked }"
                    @click="
                        $emit('update:cylinderCopy', false);
                        $emit('update:sliceIndex', number);
                        $emit('update:qty', number);
                        $emit('update:isSelected', true);
                        scrollDown();
                    "
                >
                    <div class="p-1 md:w-1/10 w-1/5" :class="{ 'md:w-1/14': mks, hidden: mks && number == 1 }">
                        <div
                            :class="[
                                active ? 'bg-gray-100' : '',
                                checked && isSelected ? 'bg-green-50 border-green-600' : 'bg-white',
                            ]"
                            class="rounded-md hover:bg-gray-50 border cursor-pointer relative shadow py-4 focus:outline-hidden hover:shadow-xl hover:border-green-800/50 transition-all outline-hidden duration-200"
                            v-if="!mks || (mks && number > 1)"
                        >
                            <div class="text-center">
                                <RadioGroupLabel as="span">
                                    {{ number }}
                                </RadioGroupLabel>
                            </div>
                            <!-- <fa
                                :icon="['fal', 'check-circle']"
                                class="hidden md:inline-block text-green-600 absolute top-5 right-4 mt-0.5 w-4"
                                v-if="checked && isSelected"
                            /> -->
                        </div>
                    </div>
                </RadioGroupOption>
            </div>

            <span
                class="link inline-block mt-2 cursor-pointer float-right"
                @click="max = mks ? 28 : 20"
                v-if="max == (mks ? 15 : 10)"
                >+ Meer dan {{ mks ? 15 : 10 }} cilinders?</span
            >
            <span
                class="link inline-block mt-2 cursor-pointer float-right"
                @click="max = mks ? 46 : 20"
                v-if="max == 28"
                >+ Meer cilinders nodig?</span
            >
            <span class="text-gray-600 block my-2 ml-1" v-if="max == (mks ? 46 : 20)"
                >Meer dan {{ max }} cilinders nodig? <a class="link" @click="showQuote()">Vraag hier</a> naar de
                mogelijkheden.</span
            >
        </RadioGroup>
    </div>

    <teleport to="#modals">
        <modal title="" ref="modal">
            <strong>Offerte aanvragen</strong>
            <template v-slot:content>
                <quote-request @close="hideQuote"></quote-request>
            </template>
        </modal>
    </teleport>
</template>

<script>
import QuoteRequest from '@/Components/QuoteRequest.vue';
import { ref } from 'vue';
const inBrowser = typeof window !== 'undefined';

export default {
    props: {
        qty: Number,
        isSelected: Boolean,
        cylinders: Object,
        sliceIndex: Number,
        cylinderCopy: Boolean,
        wizard: Boolean,
        mks: Boolean,
    },
    watch: {
        qty: {
            handler(newValue, oldValue) {
                this.changeQty(newValue, oldValue);
            },
        },
    },

    data() {
        return {};
    },

    components: {
        QuoteRequest,
    },

    methods: {
        showQuote() {
            this.$refs.modal.open = true;
        },
        hideQuote() {
            this.$refs.modal.open = false;
        },
        scrollDown() {
            if ('ontouchstart' in document.documentElement && inBrowser) {
                var step2 = document.getElementById('step2');
                if (step2) {
                    step2.scrollIntoView({ behavior: 'smooth' });
                }
            }
        },
    },

    setup(props, context) {
        const selected = ref(props.qty);
        const max = ref(props.qty > 10 ? (props.mks ? 28 : 20) : props.mks ? 15 : 10);

        function defineQty(n) {
            context.emit('update:cylinderCopy', false);
            context.emit('update:sliceIndex', n);
            context.emit('update:qty', n);
            context.emit('update:isSelected', true);
        }

        function changeQty(newValue, oldValue) {
            this.selected = newValue;

            if (props.cylinderCopy) {
                return false;
            }

            let diff = this.qty - oldValue;

            if (oldValue == 0) {
                diff--;
            }

            if (diff < 0) {
                this.cylinders.splice(props.sliceIndex, 0 - diff);
            } else {
                for (let index = 0; index < diff; index++) {
                    let base_cylinder = [];
                    if (this.mks) {
                        let number = this.cylinders.length + 1;
                        base_cylinder.push(
                            {
                                a: 30,
                                b: 30,
                                button: false,
                                panic_function: false,
                                color: false,
                                name: this.mks ? 'Cilinder ' + number : false,
                                qty: this.mks ? 1 : false,
                            },
                        );
                    } else {
                        base_cylinder.push(
                            {
                                a: this.wizard ? 30 : 0,
                                b: this.wizard ? 30 : 0,
                                button: false,
                                panic_function: false,
                                color: false,
                            },
                        );
                    }

                    this.cylinders.push(...base_cylinder);
                }
            }

            this.$emit('update:cylinders', this.cylinders);
        }

        return {
            selected,
            changeQty,
            max,
            defineQty,
        };
    },
};
</script>
